export default {
      id: "icon-arrow-down-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-arrow-down",
      toString: function () {
        return this.url;
      }
    }